import React from 'react';
import classNames from 'classnames';

const ns = `section-3`;

const Section3 = ({
	videoContentSectionHeadline,
	videoContentSectionUrl,
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	return (
		<section className={`${ rootClassnames }`}>
			<div className={`container`}>
				<h2>{videoContentSectionHeadline?.value}</h2>
				<div className={'iframe-container'}>
					<iframe
						title={videoContentSectionHeadline?.value}
						src={videoContentSectionUrl?.value}
						width={'996'}
						height={'560'}
						frameBorder={'0'}
						allow={'autoplay; fullscreen; picture-in-picture'}
						allowFullScreen
					/>
				</div>
			</div>
		</section>
	);
};

export default Section3;
